import { render } from "./index.vue?vue&type=template&id=265acc40"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "265acc40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('265acc40', __exports__)) {
    console.log('reload')
    api.reload('265acc40', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=265acc40", () => {
    console.log('re-render')
    api.rerender('265acc40', render)
  })

}


export default __exports__